module.exports = __webpack_public_path__ + "static/media/mdelivery-ubereats.eab0c789.png";